import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Menu, ShoppingCart, Settings, User, CreditCard, Gift, Wifi, Search, Shield, Bot } from "lucide-react"

const menus = [
  { name: "Main Menu", icon: Menu, description: "Primary bot navigation", commands: ["/start", "/help", "/menu"] },
  { name: "Config Menu", icon: Settings, description: "VPN configuration options", commands: ["/config", "/configs", "/free_config"] },
  { name: "Purchase Menu", icon: ShoppingCart, description: "Subscription purchase flow", commands: ["/buy", "/plans", "/pricing"] },
  { name: "Profile Menu", icon: User, description: "User profile and settings", commands: ["/profile", "/my_configs", "/usage"] },
  { name: "Payment Menu", icon: CreditCard, description: "Payment processing", commands: ["/pay", "/invoice", "/payment_history"] },
  { name: "Referral Menu", icon: Gift, description: "Referral program", commands: ["/referral", "/my_referrals", "/referral_stats"] },
  { name: "Proxy Menu", icon: Wifi, description: "Telegram proxy access", commands: ["/proxy", "/proxies", "/proxy_status"] },
  { name: "Scanner Menu", icon: Search, description: "IP and config scanning", commands: ["/scan", "/scan_status", "/scan_history"] },
  { name: "Admin Menu", icon: Shield, description: "Admin panel controls", commands: ["/admin", "/stats", "/broadcast"] },
  { name: "Bot Management", icon: Bot, description: "Multi-bot configuration", commands: ["/bots", "/add_bot", "/bot_status"] },
]

export default function MenusPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Menus</h1>
        <p className="text-muted-foreground">Bot menu configuration and commands</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {menus.map((menu) => {
          const Icon = menu.icon
          return (
            <Card key={menu.name}>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  {menu.name}
                </CardTitle>
                <Badge variant="secondary">{menu.commands.length} cmds</Badge>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground mb-3">{menu.description}</p>
                <div className="flex flex-wrap gap-1">
                  {menu.commands.map((cmd) => (
                    <Badge key={cmd} variant="outline" className="text-xs">
                      {cmd}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  )
}
